import React, { useState, Component, Fragment } from "react"
import SimpleBar from "simplebar-react"
import Shimmer from "react-shimmer-effect"
import moment from "moment"

import { Row, Col } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import DataTableBloc from "../Blocs/DataTableBloc"
import apiResponse from "../../../../../services/apiResponse"
import { ConfirmAlert } from "../../../../../helpers/ui/alert"

class HistoryComponent extends Component {
    indexViewBloc = new DataTableBloc()

    constructor(props) {
        super(props)
        this.state = {
            loadingData: true,
            histroyData: [],
        }
    }

    componentDidMount() {
        this.indexViewBloc.historyChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loadingData: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        histroyData: response,
                        loadingData: false,
                    })
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

        this.indexViewBloc.cancelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState(
                        {
                            loading: false,
                            success: true,
                            loadingTable: true,
                        },
                        function () {
                            this.fetchHistory()
                        }
                    )
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    })
                    break
                default:
                    break
            }
        })

        this.fetchHistory()
    }

    fetchHistory = async () => {
        this.indexViewBloc.fetchHistory({ uuid: this.props.uuid })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case "cancel":
                forState = {
                    confirm: false,
                }
                break
            case "confirm":
                forState = {
                    loading: true,
                    confirm: false,
                }
                this.cancelData()
                break
            case "success":
                forState = {
                    success: false,
                }
                break
            case "failed":
                forState = {
                    failed: false,
                }
                break
            default:
        }
        this.setState(forState)
    }

    cancelData = async () => {
        await this.indexViewBloc.fetchCancel({ uuid: this.props.uuid })
    }

    componentWillUnmount() {
        this.indexViewBloc.historyChannel.unsubscribe()
        this.indexViewBloc.cancelChannel.unsubscribe()
    }

    formatDuration(start, end) {
        const diff = moment.duration(end.diff(start))

        const parts = []

        if (diff.hours() > 0) {
            parts.push(`${diff.hours()} jam`)
        }
        if (diff.minutes() > 0) {
            parts.push(`${diff.minutes()} menit`)
        }
        if (diff.seconds() > 0) {
            parts.push(`${diff.seconds()} detik`)
        }

        return parts.join(" ")
    }

    render() {
        return (
            <>
                {this.state.loadingData ? (
                    <SimpleBar
                        className="activity-feed mb-0 ps-2"
                        style={{ maxHeight: "500px" }}
                    >
                        <li className="feed-item">
                            <p className="text-muted mb-1 font-size-13">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "20%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                            <p className="mt-0 mb-0">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "40%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                            <p className="mt-0 mb-0">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "40%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                        </li>
                        <li className="feed-item">
                            <p className="text-muted mb-1 font-size-13">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "20%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                            <p className="mt-0 mb-0">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "40%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                            <p className="mt-0 mb-0">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "40%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                        </li>
                        <li className="feed-item">
                            <p className="text-muted mb-1 font-size-13">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "20%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                            <p className="mt-0 mb-0">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "40%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                            <p className="mt-0 mb-0">
                                <Shimmer>
                                    <div
                                        className="shimmer"
                                        style={{ width: "40%", height: 14 }}
                                    ></div>
                                </Shimmer>
                            </p>
                        </li>
                    </SimpleBar>
                ) : (
                    <>
                        {this.state.histroyData.length > 0 ? (
                            <SimpleBar
                                className="activity-feed mb-0 ps-2"
                                style={{ maxHeight: "500px" }}
                            >
                                {this.state.histroyData.map((item, key) => {
                                    return (
                                        <li className="feed-item">
                                            <p className="mb-1 font-size-14">
                                                <span className="text-success">
                                                    <b>
                                                        {
                                                            item.tunkin_history_title
                                                        }
                                                    </b>
                                                </span>{" "}
                                                {moment(
                                                    item.run_time_start
                                                ).format("LL")}{" "}
                                                <small>
                                                    (PID{item.run_id})
                                                </small>
                                            </p>
                                            <p className="mt-0 mb-0">
                                                <div>
                                                    <span class="badge bg-info">
                                                        {item.run_time_start}
                                                    </span>{" "}
                                                    -{" "}
                                                    {item.run_time_end ? (
                                                        <span
                                                            class={`badge ${
                                                                item.run_status ===
                                                                2
                                                                    ? "bg-success"
                                                                    : "bg-danger"
                                                            }`}
                                                        >
                                                            {item.run_time_end}
                                                        </span>
                                                    ) : (
                                                        <span class="badge bg-warning">
                                                            berjalan
                                                        </span>
                                                    )}
                                                </div>
                                                {item.run_status === 1 &&
                                                    moment(item.run_time_start)
                                                        .add(30, "minutes")
                                                        .isBefore(moment()) && (
                                                        <p className="text-muted mb-0 font-size-13 fst-italic">
                                                            Kemungkinan ada
                                                            masalah,{" "}
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            confirm: true,
                                                                        }
                                                                    )
                                                                }}
                                                                style={{
                                                                    background:
                                                                        "none",
                                                                    border: "none",
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    fontStyle:
                                                                        "normal",
                                                                    color: "#0d6efd", // opsional biar tampil seperti link
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                batalkan proses
                                                            </button>
                                                        </p>
                                                    )}
                                                {item.run_status === 0 && (
                                                    <p className="text-muted mb-0 font-size-13 fst-italic">
                                                        {item.run_message}
                                                    </p>
                                                )}
                                            </p>
                                            <p className="mt-0 mb-0">
                                                <span className="fw-bolder">
                                                    <small>Durasi</small>
                                                </span>
                                                :{" "}
                                                <span>
                                                    {this.formatDuration(
                                                        moment(
                                                            item.run_time_start
                                                        ),
                                                        item.run_time_end
                                                            ? moment(
                                                                  item.run_time_end
                                                              )
                                                            : moment()
                                                    )}
                                                </span>
                                            </p>
                                        </li>
                                    )
                                })}
                            </SimpleBar>
                        ) : (
                            <p className="text-muted mb-1 font-size-13">
                                Tidak ada data riwayat
                            </p>
                        )}
                    </>
                )}
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan membatalkan proses ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil dibatalkan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal dibatalkan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </>
        )
    }
}

export default HistoryComponent
